import { useEffect, useRef } from "react";

export const useInfiniteScrollSentinel = ({
  enabled = true,
  hasNextPage = false,
  isFetchingNextPage = false,
  isLoading = false,
  onLoadMore = () => {},
  rootMargin = "0px 0px 200px 0px",
  threshold = 0.1,
} = {}) => {
  const listRef = useRef(null);
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!enabled || !listRef.current || !sentinelRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (
          entry?.isIntersecting &&
          hasNextPage &&
          !isFetchingNextPage &&
          !isLoading
        ) {
          onLoadMore();
        }
      },
      {
        root: listRef.current,
        rootMargin,
        threshold,
      }
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [
    enabled,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    onLoadMore,
    rootMargin,
    threshold,
  ]);

  return {
    listRef,
    sentinelRef,
  };
};
